import Swal from 'sweetalert2'
import api from '../../models/receiveorder'
import { QrcodeStream, QrcodeCapture } from 'vue-qrcode-reader'
import SerialModal from '../../components/modal/receiveorder_serial_modal'

export default {
  name: 'Receiveedit',
  components: {
    QrcodeStream,
    QrcodeCapture,
    SerialModal,
  },
  data() {
    return {
      search_text: '',
      modal_type: 0,
      per_page: 100,
      active_page: 1,
      isLoad: false,
      rec_id: '',
      spl_id: '',
      supplier: '',
      partstore: '',
      rec_note: '',
      rec_is_cancel: 0,
      data_edit: {},
      supplier_list: [],
      result_data: {
        pagination: [],
        count: 0,
      },
      modal_detail: {
        supplier: '',
        spl_id: 0,
        rec_id: 0,
        ps_id: '',
        recd_qty: '',
      },
      modal_edit_data: {},
      modal_scan_data: {
        recd_id: 0,
        ps_id: 0,
      },
      modal_receive_detail: {},
      receive_type: 0,
      str_data: '',
      code_data: '',
      rec_order: '000000000000000000000',
      // qr camera
      qr_camera_active: false,
      qr_camera_allow: false,
      qr_camera_message: '',
      qr_camera_pause: false,
      qr_camera_result: '',
      qr_camera_state: 1,
      qr_camera_torch_active: false,
      qr_camera_torch_not_support: false,
      // qr machine
      qr_machine_active: false,
      qr_machine_result: '',
      qr_machine_state: 1,
      qr_machine_status: 0,
      qr_machine_result_text: '',
    }
  },
  created() {
    this.checkOAuth()
    this.audio_success = new Audio('../../static/assets/sound/success.mp3')
    this.audio_error = new Audio('../../static/assets/sound/error.mp3')
  },
  mounted() {
    setTimeout(() => {
      this.rec_id =
        this.$route.query.rec_id !== undefined
          ? this.$route.query.rec_id
          : this.rec_id
      if (sessionStorage.token) {
        this.getReceiveByID()
        setTimeout(() => {
          this.activePage(1)
        }, 300)
      } else {
        setTimeout(() => {
          this.getReceiveByID()
          setTimeout(() => {
            this.activePage(1)
          }, 300)
        }, 1000)
      }
      let myModal = document.getElementById('qr_camera_modal')
      myModal.addEventListener('hide.bs.modal', (event) => {
        if (event.target.id === 'qr_camera_modal') {
          this.qr_camera_torch_active = false
        }
      })
      window.addEventListener('keypress', (e) => {
        if (this.qr_machine_active === true) {
          this.onMachineScan(e.key)
        }
      })
    }, 1000)
  },
  methods: {
    backTopage() {
      this.$router.push({
        name: 'receiveorder',
        query: this.$route.query,
      })
    },
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    activePage(value) {
      this.active_page = value
      this.search()
    },
    search() {
      this.isLoad = true
      var obj = {
        page: this.active_page,
        limit: this.per_page,
        rec_id: this.rec_id,
        search: this.search_text,
      }
      this.result_data.pagination = []
      this.result_data.count = 0
      this.header.params = obj
      api.getReceiveDetail(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.result_data = result.data
          } else {
            this.alert_msg('warning', 'Receive Detail', result.message)
          }
          this.isLoad = false
        },
        (error) => {
          this.alert_msg('error', 'Receive Detail', error.message)
          this.isLoad = false
        }
      )
    },
    ExportReceive() {
      var obj = {
        rec_id: this.rec_id,
      }
      this.header.params = obj
      api.getReceiveDetailExport(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.str_data = JSON.stringify(result.data.pagination)
            this.code_data = this.data_edit.rec_code
            setTimeout(() => {
              this.$refs.ExportText.submit()
            }, 1000)
          } else {
            this.alert_msg('warning', 'Export Receive', result.message)
          }
        },
        (error) => {
          this.alert_msg('error', 'Export Receive', error.message)
        }
      )
    },
    checkForm() {
      var $myForm = $('#formEditReceive')
      if (!$myForm[0].checkValidity()) {
        $('#formEditReceive').addClass('was-validated')
      } else {
        this.editReceive()
      }
    },
    editReceive() {
      let formData = {
        rec_id: this.rec_id,
        rec_note: this.rec_note,
      }
      api.editReceive(
        this.$store.state.URLHost,
        formData,
        this.header,
        (result) => {
          if (result.response === true) {
            this.alert_msg('success', 'Update Receive', result.message)
          } else {
            this.alert_msg('warning', 'Update Receive', result.message)
          }
        },
        (error) => {
          this.alert_msg('error', 'Update Receive', error.message)
        }
      )
    },
    getReceiveByID() {
      var obj = {
        rec_id: this.rec_id,
      }
      this.header.params = obj
      api.getReceiveByID(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.data_edit = result.data
            this.rec_order = result.data.rec_order
            this.rec_note = result.data.rec_note
            this.spl_id = result.data.spl_id
            this.supplier =
              result.data.spl_code +
              ' | ' +
              result.data.spl_name +
              ' | ' +
              result.data.spl_plant_code
            this.rec_is_cancel = result.data.rec_is_cancel
          } else {
            this.alert_msg('warning', 'Get Receive', result.message)
          }
        },
        (error) => {
          this.alert_msg('error', 'Get Receive', error.message)
        }
      )
    },
    getSupplier() {
      api.getSuplierReceive(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.supplier_list = result.data
          } else {
            this.alert_msg('warning', 'An error occurred.', result.message)
          }
        },
        (error) => {
          this.alert_msg('error', 'An error occurred.', error.message)
        }
      )
    },
    addReceiveDetail() {
      this.modal_type = 0
      this.modal_detail = {
        supplier: this.supplier,
        spl_id: this.spl_id,
        rec_id: this.rec_id,
        ps_id: '',
        recd_qty: '',
      }
      this.ModalBoots('ReceiveDetailModal').show()
    },
    editReceiveDetail(obj) {
      this.modal_type = 1
      this.modal_detail_edit = obj
      this.modal_edit_data = {
        supplier: this.supplier,
        partstore:
          obj.pr_id_number + ' | ' + obj.pr_number + ' | ' + obj.pr_name,
      }
      this.ModalBoots('ReceiveDetailModal').show()
    },
    scanSerial(obj) {
      this.modal_type = 2
      this.modal_scan_data.recd_id = obj.recd_id
      this.modal_scan_data.ps_id = obj.ps_id
      if (
        this.modal_scan_data.recd_id !== '' &&
        this.modal_scan_data.recd_id !== undefined
      ) {
        this.ModalBoots('ScanModal').show()
      }
    },
    showReceiveSerial(obj, receive_type) {
      this.modal_type = 3
      this.modal_receive_detail = obj
      this.receive_type = receive_type
      this.ModalBoots('ReceiveorderSerialModal').show()
    },
    removeReceiveDetail(rs) {
      Swal.fire({
        title: 'Remove Receive Detail',
        text: 'You want to remove this Receive ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#67757c',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.value) {
          $('.preloader').fadeIn()
          var obj = {
            recd_id: rs.recd_id,
          }
          this.header.params = obj
          api.removeReceiveDetail(
            this.$store.state.URLHost,
            this.header,
            (result) => {
              if (result.response === true) {
                if (this.result_data.pagination.length === 1) {
                  if (this.active_page <= 1) {
                    this.active_page = 1
                  } else {
                    this.active_page--
                  }
                }
                this.search()
                this.alert_msg('success', 'Remove Receive', result.message)
                $('.preloader').fadeOut()
              } else {
                $('.preloader').fadeOut()
                this.search()
                this.alert_msg('warning', 'Remove Receive', result.message)
              }
            },
            (error) => {
              $('.preloader').fadeOut()
              this.alert_msg('error', 'Remove Receive', error.message)
            }
          )
        }
      })
    },
    cancelReceive(rec_id) {
      Swal.fire({
        title: 'Cancel Receive',
        text: 'You want to cancel this Receive ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#67757c',
        confirmButtonText: 'Yes, Cancel it!',
        cancelButtonText: 'Close',
      }).then((result) => {
        if (result.value) {
          $('.preloader').fadeIn()
          var obj = {
            rec_id: rec_id,
            rec_is_cancel: 1,
          }
          this.header.params = obj
          api.cancelReceive(
            this.$store.state.URLHost,
            this.header,
            (result) => {
              if (result.response === true) {
                if (this.result_data.pagination.length === 1) {
                  if (this.active_page <= 1) {
                    this.active_page = 1
                  } else {
                    this.active_page--
                  }
                }
                this.getReceiveByID()
                this.search()
                this.alert_msg('success', 'Cancel Receive', result.message)
                $('.preloader').fadeOut()
              } else {
                $('.preloader').fadeOut()
                this.getReceiveByID()
                this.search()
                this.alert_msg('warning', 'Cancel Receive', result.message)
              }
            },
            (error) => {
              $('.preloader').fadeOut()
              this.alert_msg('error', 'Cancel Receive', error.message)
            }
          )
        }
      })
    },
    cancelReceiveDetail(rec_id, recd_id) {
      Swal.fire({
        title: 'Cancel Receive Detail',
        text: 'You want to cancel this Receive Detail ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#67757c',
        confirmButtonText: 'Yes, Cancel it!',
        cancelButtonText: 'Close',
      }).then((result) => {
        if (result.value) {
          $('.preloader').fadeIn()
          var obj = {
            rec_id: rec_id,
            recd_id: recd_id,
            recd_is_cancel: 1,
          }
          this.header.params = obj
          api.cancelReceiveDetail(
            this.$store.state.URLHost,
            this.header,
            (result) => {
              if (result.response === true) {
                this.getReceiveByID()
                this.search()
                this.alert_msg(
                  'success',
                  'Cancel Receive Detail',
                  result.message
                )
                $('.preloader').fadeOut()
              } else {
                $('.preloader').fadeOut()
                this.getReceiveByID()
                this.search()
                this.alert_msg(
                  'warning',
                  'Cancel Receive Detail',
                  result.message
                )
              }
            },
            (error) => {
              $('.preloader').fadeOut()
              this.alert_msg('error', 'Cancel Receive Detail', error.message)
            }
          )
        }
      })
    },
    // camera scan
    startCameraScan() {
      this.qr_camera_active = true
      this.qr_camera_pause = false
      $('#qr_camera_modal').modal('show')
    },
    stopCameraScan() {
      $('#qr_camera_modal').modal('hide')
      setTimeout(() => {
        this.qr_camera_active = false
        this.qr_camera_pause = true
      }, 200)
    },
    async onInit(promise) {
      try {
        const { capabilities } = await promise
        this.qr_camera_torch_not_support = !capabilities.torch
        this.qr_camera_active = true
      } catch (error) {
        this.qr_camera_active = false
        if (error.name === 'NotAllowedError') {
          this.qr_camera_message = 'You need to grant camera access permisson.'
        } else if (error.name === 'NotFoundError') {
          this.qr_camera_message = 'No camera on this device.'
        } else if (error.name === 'NotSupportedError') {
          this.qr_camera_message = 'Secure context required (HTTPS, localhost).'
        } else if (error.name === 'NotReadableError') {
          this.qr_camera_message = 'Is the camera already in use.'
        } else if (error.name === 'OverconstrainedError') {
          this.qr_camera_message = 'Installed cameras are not suitable.'
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.qr_camera_message =
            'Stream API is not supported in this browser.'
        }
      }
    },
    onDecode(result) {
      this.qr_camera_result = result
      this.qr_camera_pause = true
      let form_data = {
        rec_id: this.rec_id,
        serial_no: result,
      }
      api.addSerialTemp(
        this.$store.state.URLHost,
        form_data,
        this.header,
        (result) => {
          if (result.response === true) {
            // this.isu_dts.push(result.data)
            this.search()
            // this.checkAllow()
            this.soundSuccess()
            this.qr_camera_state = 2
          } else {
            this.soundError()
            this.qr_camera_state = 3
          }
          setTimeout(() => {
            this.qr_camera_result = ''
            this.qr_camera_state = 1
            this.qr_camera_pause = false
          }, 1000)
        },
        (error) => {
          this.alert_msg('error', 'An error occurred.', error.message)
          this.soundError()
          setTimeout(() => {
            this.qr_camera_result = ''
            this.qr_camera_state = 1
            this.qr_camera_pause = false
          }, 1000)
        }
      )
    },
    // machine scan
    startMachineScan() {
      this.qr_machine_active = true
      this.qr_machine_state = 1
      this.qr_machine_result = ''
      this.qr_machine_result_text = ''
      $('#qr_machine_modal').modal('show')
    },
    stopMachineScan() {
      this.qr_machine_active = false
      this.qr_machine_state = 1
      this.qr_machine_result = ''
      this.qr_machine_result_text = ''
      $('#qr_machine_modal').modal('hide')
    },
    resetMachineScan() {
      this.qr_machine_state = 0
      setTimeout(() => {
        this.qr_machine_active = true
        this.qr_machine_state = 1
        this.qr_machine_result = ''
        this.qr_machine_result_text = ''
      }, 1000)
    },
    onMachineScan(key) {
      if (key === 'Enter') {
        // console.log(this.qr_machine_result)
        this.qr_machine_active = false
        let form_data = {
          rec_id: this.rec_id,
          serial_no: this.qr_machine_result,
        }
        api.addSerialTemp(
          this.$store.state.URLHost,
          form_data,
          this.header,
          (result) => {
            if (result.response === true) {
              // this.isu_dts.push(result.data)
              this.search()
              this.qr_machine_state = 3
              this.qr_machine_status = 1
              this.qr_machine_result_text = result.data.id
              // this.checkAllow()
              this.soundSuccess()
            } else {
              this.qr_machine_state = 3
              this.qr_machine_status = 0
              this.soundError()
            }
            setTimeout(() => {
              this.qr_machine_state = 1
              this.qr_machine_result = ''
              this.qr_machine_active = true
            }, 1000)
          },
          (error) => {
            this.alert_msg('error', 'An error occurred.', error.message)
            this.soundError()
            setTimeout(() => {
              this.qr_machine_state = 1
              this.qr_machine_result = ''
              this.qr_machine_active = true
            }, 1000)
          }
        )
      } else {
        if (key.length === 1 && /[a-zA-Z0-9- ]/.test(key)) {
          this.qr_machine_result += key
        }
        if (this.qr_machine_result.length === 0) {
          this.qr_machine_state = 1
        } else {
          this.qr_machine_state = 2
        }
      }
    },
    soundSuccess() {
      // this.audio_success.currentTime = 0
      this.audio_success.play()
    },
    soundError() {
      // this.audio_error.currentTime = 0
      this.audio_error.play()
    },
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/receiveorderedit.js